import React from 'react'
import { Button } from 'react-bootstrap'

const IconButton = ({ icon = '', onClick = () => null, className = '', ...rest }) => {
  return (
    <Button className={`py-0 px-1 ${className}`} onClick={onClick} {...rest}>
      <i className={`${icon} fa-fw me-0`} />
    </Button>
  )
}

export default IconButton
